import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation MarketoTrackEvent(
    $eventName: MarketoEventsEnum!
    $primaryValue: String!
    $attributes: JSON
  ) {
    marketoTrackEvent(eventName: $eventName, primaryValue: $primaryValue, attributes: $attributes) {
      id
    }
  }
`;

export function trackMarketoEvent(eventName: string, primaryValue: string, attributes: object) {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: {
      eventName,
      primaryValue,
      attributes: stringifyIfPresent(attributes),
    },
  }).then(({ data }) => getSingleProp(data));
}
